import { getIcbThunk } from '../../../../common/category/store/thunk'
import { Director } from '../../../../companyAnalysis/companyProfile/director'
import { Industry } from '../../../../companyAnalysis/companyProfile/industry'
import { Management } from '../../../../companyAnalysis/companyProfile/management'
import { Overview } from '../../../../companyAnalysis/companyProfile/overview'
import { getCompanyInfoDetail } from '../../../../companyAnalysis/companyProfile/store/thunk'
import { getUnique } from '../../../../helpers/common'
import { MAIN_SCREEN, SCREEN, TYPE_ITEM_SETTING } from '../../constant'
import { mapThunkCommon } from '../thunkCommon'

const PANELS = {
  COMPANY_OVERVIEW: 'companyOverview',
  INDUSTRY_CLASSIFICATION: 'industryClassification',
  BOARD_OF_MANAGEMENT: 'boardOfManagement',
  BOARD_OF_DIRECTOR: 'boardOfDirector',
}

export const getPanelListCompanyProfile = () => {
  return [
    {
      label: 'dynamicReport.COMPANY_PROFILE',
      children: [
        {
          screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].COMPANY_PROFILE,
          panel: PANELS.COMPANY_OVERVIEW,
          label: 'dynamicReport.COMPANY_OVERVIEW',
          type: TYPE_ITEM_SETTING.PANEL,
        },
        {
          screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].COMPANY_PROFILE,
          panel: PANELS.INDUSTRY_CLASSIFICATION,
          label: 'dynamicReport.INDUSTRY_CLASSIFICATION',
          type: TYPE_ITEM_SETTING.PANEL,
        },
        {
          screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].COMPANY_PROFILE,
          panel: PANELS.BOARD_OF_MANAGEMENT,
          label: 'dynamicReport.BOARD_OF_MANAGEMENT',
          type: TYPE_ITEM_SETTING.PANEL,
        },
        {
          screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].COMPANY_PROFILE,
          panel: PANELS.BOARD_OF_DIRECTOR,
          label: 'dynamicReport.BOARD_OF_DIRECTOR',
          type: TYPE_ITEM_SETTING.PANEL,
        },
      ],
    },
  ]
}

export const getPanelCompanyProfile = (panel) => {
  switch (panel) {
    case PANELS.COMPANY_OVERVIEW: {
      return {
        renderComponent: () => {
          return <Overview isDynamicReport />
        },
        thunk: [
          ({ companyInfo }) =>
            getCompanyInfoDetail({
              OrganizationId: companyInfo.organizationId,
            }),
        ],
        isWaitForMount: false,
        isTable: false,
      }
    }
    case PANELS.INDUSTRY_CLASSIFICATION: {
      return {
        renderComponent: () => {
          return <Industry />
        },
        dependThunks: [mapThunkCommon.ALL_VSICS],
        thunk: [
          () => getIcbThunk(),
          ({ companyInfo }) =>
            getCompanyInfoDetail({
              OrganizationId: companyInfo.organizationId,
            }),
        ],
        isWaitForMount: false,
        isTable: false,
      }
    }
    case PANELS.BOARD_OF_MANAGEMENT: {
      return {
        renderComponent: () => {
          return <Management isDynamicReport />
        },
        thunk: [
          ({ companyInfo }) =>
            getCompanyInfoDetail({
              OrganizationId: companyInfo.organizationId,
            }),
        ],
        isWaitForMount: false,
        isTable: true,
      }
    }
    case PANELS.BOARD_OF_DIRECTOR: {
      return {
        renderComponent: () => {
          return <Director isDynamicReport />
        },
        thunk: [
          ({ companyInfo }) =>
            getCompanyInfoDetail({
              OrganizationId: companyInfo.organizationId,
            }),
        ],
        isWaitForMount: false,
        isTable: true,
      }
    }
    default:
      break
  }
}

export const getDefaultCompanyProfile = () => {
  return getPanelListCompanyProfile()[0].children.map((panel) => ({
    id: getUnique(),
    ...panel,
  }))
}
